exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".LpcVb_9wO3glYwjfkaRbL{padding-inline-start:20px;padding-inline-end:20px}@media only screen and (min-width: 480px){.LpcVb_9wO3glYwjfkaRbL{padding-inline-start:36px;padding-inline-end:36px}}@media only screen and (min-width: 1280px){.LpcVb_9wO3glYwjfkaRbL{padding-inline-start:52px;padding-inline-end:52px}}._2SuBpv-Fq64muNU-8d0Cr6{margin-inline-start:20px;margin-inline-end:20px}@media only screen and (min-width: 480px){._2SuBpv-Fq64muNU-8d0Cr6{margin-inline-start:36px;margin-inline-end:36px}}@media only screen and (min-width: 1280px){._2SuBpv-Fq64muNU-8d0Cr6{margin-inline-start:52px;margin-inline-end:52px}}.tmsWVZw39-8uMao44pVcq{display:none}._1t6UsApYIHRa1ARNRl_xCX{z-index:6;box-sizing:border-box;position:fixed;top:24px;inset-inline-end:42px;transform:rotate(90deg)}\n", ""]);

// exports
exports.locals = {
	"grid-sides": "LpcVb_9wO3glYwjfkaRbL",
	"gridSides": "LpcVb_9wO3glYwjfkaRbL",
	"grid-sides-margins": "_2SuBpv-Fq64muNU-8d0Cr6",
	"gridSidesMargins": "_2SuBpv-Fq64muNU-8d0Cr6",
	"hidden": "tmsWVZw39-8uMao44pVcq",
	"context-menu-container": "_1t6UsApYIHRa1ARNRl_xCX",
	"contextMenuContainer": "_1t6UsApYIHRa1ARNRl_xCX"
};